/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/

import { css, StyleSheet } from 'aphrodite';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { stylePropType } from 'tss-core-lib-common';
import React from 'react';

let styles;

const ItemLink = ( {
  label,
  url,
  leftSrc,
  leftStyle,
  imgSrc,
  style,
  imgStyle,
  external,
} ) => {
  const children = (
    <div className={ css( styles.itemLinkInner, style ) }>
      { leftSrc && (
        <img
          src={ leftSrc }
          alt="mini"
          className={ css( styles.leftSrc, leftStyle ) }
        />
      ) }
      <img
        src={ imgSrc }
        className={ css( styles.itemLinkImg, imgStyle ) }
        alt={ label }
      />
      <span className={ css( styles.itemLinkLabel ) }>{ label }</span>
    </div>
  );

  return external ? (
    <a target="_blank" href={ url } className={ css( styles.itemLink ) }>
      { children }
    </a>
  ) : (
    <NavLink to={ url } className={ css( styles.itemLink ) }>
      { children }
    </NavLink>
  );
};

ItemLink.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  imgStyle: stylePropType.isRequired,
  style: stylePropType.isRequired,
  leftStyle: stylePropType,
  external: PropTypes.bool,
  leftSrc: PropTypes.string,
};

ItemLink.defaultProps = {
  external: true,
  leftSrc: null,
  leftStyle: null,
};

styles = StyleSheet.create( {
  container: {
    width: '100%',
  },

  content: {
    maxWidth: '706px',
    margin: '14rem auto 0 auto',
    display: 'flex',
    flexWrap: 'wrap',
  },

  itemLink: {
    cursor: 'pointer',
    textDecoration: 'none',
    outline: 0,
    margin: '0.9rem',
  },

  itemLinkInner: {
    width: '21.7rem',
    height: '21.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    transition: 'box-shadow 0.15s linear',
    boxShadow: 0,

    ':hover': {
      boxShadow: '0 4px 10px 0 rgba(0,0,0,0.3)',
    },
  },

  itemLinkImg: {
    position: 'relative',
    top: '-5%',
  },

  leftSrc: {
    marginLeft: '-28px',
    paddingRight: '20px',
    marginBottom: '20px',
  },
  itemLinkLabel: {
    position: 'absolute',
    left: 0,
    right: 0,
    // bottom: '4rem',
    bottom: '2rem',
    fontSize: '1.6rem',
    fontWeight: 600,
    color: 'white',
    textAlign: 'center',
  },
} );
export default ItemLink;



// WEBPACK FOOTER //
// ./src/components/ItemLink.js